import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { t } from '../../../utils/i18next';
import { numberToCurrency } from '../../../utils/String';
import styled from 'styled-components';
import DiscountCircle from '../../assets/icons/discount-circle-dash.svg';
import { media } from '../../theme/styledMedia';
import { STANDARD_RADIUS } from '../../theme/constantUnits';
import { spacingInRems } from '../../theme/themeUtils';
import { dateToOrdinalDay } from '../../../utils/Date';

const StyledTypography = styled(Typography)`
  && {
    border-radius: ${STANDARD_RADIUS};
    color: ${({ theme }) => theme.palette.green};
    width: ${props => (props.$fullWidth ? '100%' : 'fit-content')};
    background-color: ${({ theme }) => theme.palette.lightGreenBackground};
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: start;
    padding: ${spacingInRems(0.5)};
    & #discount-icon {
      display: flex;
      padding-right: 5px;
    }

    ${media.md`
        margin-top: ${spacingInRems(1)};
    `}
  }
`;

const DiscountHeader = ({
  discountData,
  includeDate,
  textVariant,
  fullWidth = true
}) => {
  const translationBase = 'payment_option';

  function getTextToShow(discountData, includeDate) {
    const amountInCurrency = numberToCurrency(discountData.amount);
    if (includeDate) {
      return t(`${translationBase}.discount.offer_with_date`, {
        amount: amountInCurrency,
        expirationDate: dateToOrdinalDay(discountData.expirationDate)
      });
    } else {
      return t(`${translationBase}.discount.offer`, {
        amount: amountInCurrency
      });
    }
  }

  let textToShow = getTextToShow(discountData, includeDate);
  return (
    <StyledTypography
      $fullWidth={fullWidth}
      className={'discount-header'}
      data-testid={'discount-data'}
      color={'secondary'}
      variant={textVariant}
    >
      <div id="discount-icon">
        <img src={DiscountCircle} alt={'discount-icon'} />
      </div>

      <div>{textToShow}</div>
    </StyledTypography>
  );
};

DiscountHeader.propTypes = {
  includeDate: PropTypes.bool,
  fullWidth: PropTypes.bool,
  textVariant: PropTypes.string,
  discountData: PropTypes.shape({
    amount: PropTypes.number,
    expirationDate: PropTypes.string
  })
};

export default DiscountHeader;
